import { Button, FormControl, makeStyles, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import clsx from 'clsx';
import AdminTitle from "components/admin/smart-visa/AdminTitle";
import AdminTitle2 from "components/admin/smart-visa/AdminTitle2";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { approveConfigTimes, getConfigTimes, updateConfigTimes } from "redux/modules/configTimeSlice";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: '#F7FAFC',
    },
  },
}))(TableRow);

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(4),
    borderRadius: 16,
  },
  content: {
    marginTop: 30
  },
  warpSubHeader: {
    marginTop: 20,
    display: "flex", justifyContent: "space-between", alignItems: "center"
  },
  buttonDialogSave: {
    width: '100%',
    margin: '15px 5px'
  },
  table: {
    minWidth: 700,
  },
  tableHead: {
    backgroundColor: '#F1F3F9',
    color: '#172B4D',
    textAlign: 'center',
    fontSize: 16,
    fontWeight: 'bold'
  },

  warpButtonDetail: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'right'
  },
  center: {
    textAlign: 'center'
  },
  btnActive: {
    color: '#2DCE98',
    border: '1px solid #2DCE98',
    backgroundColor: ' white',
    marginRight: 10,
    width: 75
  },
  btnInActive: {
    color: '#F53C56',
    border: '1px solid #F53C56',
    backgroundColor: ' white',
    marginRight: 10,
    width: 75
  },
  formControl: {
    width: 75,
    marginRight: 10
  },
  textRight: {
    textAlign: 'right'
  },
  textLeft: {
    textAlign: 'left'
  },
  textField: {
    backgroundColor: 'white'
  },
  timeControl: {
    width: 150,
    textAlign: 'center'
  }
}));





function ConfigRequest() {

  const classes = useStyles();
  const dispatch = useDispatch();
  const { list: configTimeList } = useSelector((state) => state.configTime);
  const profile = useSelector((state) => state.user.profile);

  useEffect(async () => {
    await getConfigTimesList();
  }, []);

  const getConfigTimesList = async () => {
    await dispatch(getConfigTimes());
  }
  const [configs, setConfigs] = React.useState([]);


  const getConfig = (configName) => {
    return configTimeList.find(x => x.configName === configName);
  }

  useEffect(() => {
    const rawconfigs = [
      {
        header: 'การรับรองคุณสมบัติ',
        rows: [
          {
            configName: 'qualification_userrequest_expired',
            hours: getConfig('qualification_userrequest_expired')?.hours,
            days: getConfig('qualification_userrequest_expired')?.days,
            hourFactor: getConfig('qualification_userrequest_expired')?.hourFactor,
            lasthours: getConfig('qualification_userrequest_expired')?.hours,
            lastdays: getConfig('qualification_userrequest_expired')?.days,
            lasthourFactor: getConfig('qualification_userrequest_expired')?.hourFactor,
            isApproved: getConfig('qualification_userrequest_expired')?.isApproved,
            empRequestChange: getConfig('qualification_userrequest_expired')?.empRequestChange,
            approvedCount: getConfig('qualification_userrequest_expired')?.approvedCount,
            description: 'ระยะเวลาที่ผู้ยื่นคำขอพิจารณาคุณสมบัติ',
          }
        ]
      },
      {
        header: 'ขออนุมัติตำแหน่งหน้าที่ของคนต่างด้าว',
        rows: [
          {
            configName: 'T1_1',
            hours: getConfig('T1_1')?.hours,
            days: getConfig('T1_1')?.days,
            hourFactor: getConfig('T1_1')?.hourFactor,
            lasthours: getConfig('T1_1')?.hours,
            lastdays: getConfig('T1_1')?.days,
            lasthourFactor: getConfig('T1_1')?.hourFactor,
            isApproved: getConfig('T1_1')?.isApproved,
            empRequestChange: getConfig('T1_1')?.empRequestChange,
            approvedCount: getConfig('T1_1')?.approvedCount,
            description: 'ขออนุมัติตำแหน่งคนต่างด้าว',
          },
          {
            configName: 'T1_2',
            hours: getConfig('T1_2')?.hours,
            days: getConfig('T1_2')?.days,
            hourFactor: getConfig('T1_2')?.hourFactor,
            lasthours: getConfig('T1_2')?.hours,
            lastdays: getConfig('T1_2')?.days,
            lasthourFactor: getConfig('T1_2')?.hourFactor,
            isApproved: getConfig('T1_2')?.isApproved,
            empRequestChange: getConfig('T1_2')?.empRequestChange,
            approvedCount: getConfig('T1_2')?.approvedCount,
            description: 'ขอยกเลิกตำแหน่งหน้าที่ที่ได้รับอนุมัติของคนต่างด้าว',
          }
        ]
      },
      {
        header: 'ขอบรรจุคนต่างด้าวหรือครอบครัว',
        rows: [
          {
            configName: 'T4_1',
            hours: getConfig('T4_1')?.hours,
            days: getConfig('T4_1')?.days,
            hourFactor: getConfig('T4_1')?.hourFactor,
            lasthours: getConfig('T4_1')?.hours,
            lastdays: getConfig('T4_1')?.days,
            lasthourFactor: getConfig('T4_1')?.hourFactor,
            isApproved: getConfig('T4_1')?.isApproved,
            empRequestChange: getConfig('T4_1')?.empRequestChange,
            approvedCount: getConfig('T4_1')?.approvedCount,
            description: 'ขอบรรจุคนต่างด้าวและขออนุญาตให้ครอบครัวเข้ามาในประเทศ',
          },
          {
            configName: 'T4_2',
            hours: getConfig('T4_2')?.hours,
            days: getConfig('T4_2')?.days,
            hourFactor: getConfig('T4_2')?.hourFactor,
            lasthours: getConfig('T4_2')?.hours,
            lastdays: getConfig('T4_2')?.days,
            lasthourFactor: getConfig('T4_2')?.hourFactor,
            isApproved: getConfig('T4_2')?.isApproved,
            empRequestChange: getConfig('T4_2')?.empRequestChange,
            approvedCount: getConfig('T4_2')?.approvedCount,
            description: 'ขออนุญาตให้ครอบครัวของคนต่างด้าวเข้ามาในประเทศ',
          },
          {
            configName: 'T4_3',
            hours: getConfig('T4_3')?.hours,
            days: getConfig('T4_3')?.days,
            hourFactor: getConfig('T4_3')?.hourFactor,
            lasthours: getConfig('T4_3')?.hours,
            lastdays: getConfig('T4_3')?.days,
            lasthourFactor: getConfig('T4_3')?.hourFactor,
            isApproved: getConfig('T4_3')?.isApproved,
            empRequestChange: getConfig('T4_3')?.empRequestChange,
            approvedCount: getConfig('T4_3')?.approvedCount,
            description: 'ขอบรรจุคนต่างด้าวและขออนุญาตให้ครอบครัวเข้ามาในประเทศ (นักบิน)',
          },
          {
            configName: 'T4_4',
            hours: getConfig('T4_4')?.hours,
            days: getConfig('T4_4')?.days,
            hourFactor: getConfig('T4_4')?.hourFactor,
            lasthours: getConfig('T4_4')?.hours,
            lastdays: getConfig('T4_4')?.days,
            lasthourFactor: getConfig('T4_4')?.hourFactor,
            isApproved: getConfig('T4_4')?.isApproved,
            empRequestChange: getConfig('T4_4')?.empRequestChange,
            approvedCount: getConfig('T4_4')?.approvedCount,
            description: 'ขอบรรจุคนต่างด้าวและขออนุญาตให้ครอบครัวเข้ามาในประเทศ (Operator หรือใกล้เคียง)',
          }
        ]
      },
      {
        header: 'ขออนุญาตให้คนต่างด้าวมาปฎิบัติงาน',
        rows: [
          {
            configName: 'T5_1',
            hours: getConfig('T5_1')?.hours,
            days: getConfig('T5_1')?.days,
            hourFactor: getConfig('T5_1')?.hourFactor,
            lasthours: getConfig('T5_1')?.hours,
            lastdays: getConfig('T5_1')?.days,
            lasthourFactor: getConfig('T5_1')?.hourFactor,
            isApproved: getConfig('T5_1')?.isApproved,
            empRequestChange: getConfig('T5_1')?.empRequestChange,
            approvedCount: getConfig('T5_1')?.approvedCount,
            description: 'ขออนุญาตให้คนต่างด้าวมาปฎิบัติงานชั่วคราวเป็นการเร่งด่วน (30 วัน)',
          },
          {
            configName: 'T5_2',
            hours: getConfig('T5_2')?.hours,
            days: getConfig('T5_2')?.days,
            hourFactor: getConfig('T5_2')?.hourFactor,
            lasthours: getConfig('T5_2')?.hours,
            lastdays: getConfig('T5_2')?.days,
            lasthourFactor: getConfig('T5_2')?.hourFactor,
            isApproved: getConfig('T5_2')?.isApproved,
            empRequestChange: getConfig('T5_2')?.empRequestChange,
            approvedCount: getConfig('T5_2')?.approvedCount,
            description: 'ขออนุญาตให้คนต่างด้าวมาปฎิบัติงานชั่วคราว (ไม่เกิน 6 เดือน)',
          }
        ]
      },
      {
        header: 'ขอความร่วมมือในการประทับคราวีซ่า',
        rows: [
          {
            configName: 'T6_1',
            hours: getConfig('T6_1')?.hours,
            days: getConfig('T6_1')?.days,
            hourFactor: getConfig('T6_1')?.hourFactor,
            lasthours: getConfig('T6_1')?.hours,
            lastdays: getConfig('T6_1')?.days,
            lasthourFactor: getConfig('T6_1')?.hourFactor,
            isApproved: getConfig('T6_1')?.isApproved,
            empRequestChange: getConfig('T6_1')?.empRequestChange,
            approvedCount: getConfig('T6_1')?.approvedCount,
            description: 'ขอความร่วมมือในการประทับตราวีซ่าของคนต่างด้าวและครอบครัว',
          },
          {
            configName: 'T6_2',
            hours: getConfig('T6_2')?.hours,
            days: getConfig('T6_2')?.days,
            hourFactor: getConfig('T6_2')?.hourFactor,
            lasthours: getConfig('T6_2')?.hours,
            lastdays: getConfig('T6_2')?.days,
            lasthourFactor: getConfig('T6_2')?.hourFactor,
            isApproved: getConfig('T6_2')?.isApproved,
            empRequestChange: getConfig('T6_2')?.empRequestChange,
            approvedCount: getConfig('T6_2')?.approvedCount,
            description: 'ขอความร่วมมือในการประทับตราวีซ่าของครอบครัวคนต่างด้าว',
          }
        ]
      },
      {
        header: 'ขออนุญาตให้คนต่างด้าวไปปฏิบัติงานเพิ่มเติม',
        rows: [
          {
            configName: 'T7_1',
            hours: getConfig('T7_1')?.hours,
            days: getConfig('T7_1')?.days,
            hourFactor: getConfig('T7_1')?.hourFactor,
            lasthours: getConfig('T7_1')?.hours,
            lastdays: getConfig('T7_1')?.days,
            lasthourFactor: getConfig('T7_1')?.hourFactor,
            isApproved: getConfig('T7_1')?.isApproved,
            empRequestChange: getConfig('T7_1')?.empRequestChange,
            approvedCount: getConfig('T7_1')?.approvedCount,
            description: 'ขออนุญาตให้คนต่างด้าวไปปฎิบัติงานเพิ่มเติมที่บริษัทในเครือเดียวกัน',
          },
          {
            configName: 'T7_2',
            hours: getConfig('T7_2')?.hours,
            days: getConfig('T7_2')?.days,
            hourFactor: getConfig('T7_2')?.hourFactor,
            lasthours: getConfig('T7_2')?.hours,
            lastdays: getConfig('T7_2')?.days,
            lasthourFactor: getConfig('T7_2')?.hourFactor,
            isApproved: getConfig('T7_2')?.isApproved,
            empRequestChange: getConfig('T7_2')?.empRequestChange,
            approvedCount: getConfig('T7_2')?.approvedCount,
            description: 'ขออนุญาตให้คนต่างด้าวไปปฎิบัติงานเพิ่มเติม (หอการค้าต่างประเทศในประเทศไทย)',
          }
        ]
      },
      {
        header: 'ขอขยายเวลาของตำแหน่งงาน',
        rows: [
          {
            configName: 'T8_1',
            hours: getConfig('T8_1')?.hours,
            days: getConfig('T8_1')?.days,
            hourFactor: getConfig('T8_1')?.hourFactor,
            lasthours: getConfig('T8_1')?.hours,
            lastdays: getConfig('T8_1')?.days,
            lasthourFactor: getConfig('T8_1')?.hourFactor,
            isApproved: getConfig('T8_1')?.isApproved,
            empRequestChange: getConfig('T8_1')?.empRequestChange,
            approvedCount: getConfig('T8_1')?.approvedCount,
            description: 'ขอขยายเวลาของตำแหน่งคนต่างด้าวและต่ออายุการอยุ่ในประเทศของคนต่างด้าวและครอบครัว',
          }
        ]
      },
      {
        header: 'ขอเปลี่ยนชื่อ-สกุลคนต่างด้าว',
        rows: [
          {
            configName: 'T11_1',
            hours: getConfig('T11_1')?.hours,
            days: getConfig('T11_1')?.days,
            hourFactor: getConfig('T11_1')?.hourFactor,
            lasthours: getConfig('T11_1')?.hours,
            lastdays: getConfig('T11_1')?.days,
            lasthourFactor: getConfig('T11_1')?.hourFactor,
            isApproved: getConfig('T11_1')?.isApproved,
            empRequestChange: getConfig('T11_1')?.empRequestChange,
            approvedCount: getConfig('T11_1')?.approvedCount,
            description: 'ขอเปลี่ยนชื่อ-สกุลคนต่างด้าว',
          },
          {
            configName: 'T11_2',
            hours: getConfig('T11_2')?.hours,
            days: getConfig('T11_2')?.days,
            hourFactor: getConfig('T11_2')?.hourFactor,
            lasthours: getConfig('T11_2')?.hours,
            lastdays: getConfig('T11_2')?.days,
            lasthourFactor: getConfig('T11_2')?.hourFactor,
            isApproved: getConfig('T11_2')?.isApproved,
            empRequestChange: getConfig('T11_2')?.empRequestChange,
            approvedCount: getConfig('T11_2')?.approvedCount,
            description: 'ขอเปลี่ยนชื่อ-สกุลครอบครัวคนต่างด้าว',
          }
        ]
      },
      {
        header: 'ขอใช้ช่องทางพิเศษ',
        rows: [
          {
            configName: 'T16_2',
            hours: getConfig('T16_2')?.hours,
            days: getConfig('T16_2')?.days,
            hourFactor: getConfig('T16_2')?.hourFactor,
            lasthours: getConfig('T16_2')?.hours,
            lastdays: getConfig('T16_2')?.days,
            lasthourFactor: getConfig('T16_2')?.hourFactor,
            isApproved: getConfig('T16_2')?.isApproved,
            empRequestChange: getConfig('T16_2')?.empRequestChange,
            approvedCount: getConfig('T16_2')?.approvedCount,
            description: 'ขออนุญาตให้คนต่างด้าวและครอบครัวใช้สิทธิผ่านช่องทางพิเศษ (In-Out)',
          }
        ]
      },
    ];
    setConfigs(rawconfigs);
  }, [configTimeList]);


  const handleSave = async () => {
    const body = [];
    configs.forEach(c => {
      c.rows.filter(x =>
        x.hours !== x.lasthours
        || x.days !== x.lastdays
        || x.hourFactor !== x.lasthourFactor
      ).forEach(r => {
        body.push({
          hours: +r.hours,
          days: +r.days,
          hourFactor: +r.hourFactor || 8,
          configName: r.configName,
        })
      });
    });

    await dispatch(updateConfigTimes({ list: body }));
    await getConfigTimesList();
  }

  const handleApproveTime = async (row) => {
    const configTime = configTimeList.find(x => row.configName === x.configName);
    if (configTime) {
      await dispatch(approveConfigTimes({ configTimeId: configTime.configTimeId }));
      await getConfigTimesList();
    }


  }


  return (
    <Paper className={classes.paper}>
      <AdminTitle title="Setting" subTitle="กำหนดเวลาคำขอ" />
      <div className={classes.warpSubHeader} >
        <AdminTitle2 subTitle="กำหนดเวลาคำขอ" />

        <div>
          <Button variant="contained" size="medium" color="primary" onClick={() => handleSave()} className={classes.buttonDialogSave}>
            บันทึก
          </Button>
        </div>

      </div>
      <div className={classes.content}>
        <div className={classes.warpData}>

          {
            configs.map((r, index) => (
              <TableContainer key={index}>
                <Table className={classes.table} aria-label="customized table">
                  <TableHead >
                    <TableRow>
                      <StyledTableCell className={clsx(classes.tableHead, classes.textLeft)}>     {r.header}</StyledTableCell>
                      <StyledTableCell className={classes.tableHead} style={{ 'width': 100 }}>วัน</StyledTableCell>
                      <StyledTableCell className={classes.tableHead} style={{ 'width': 100 }}>ชั่วโมง</StyledTableCell>
                      <StyledTableCell className={classes.tableHead} style={{ 'width': 150 }}>การนับวลา</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>

                    {
                      r.rows.map((r2, index2) => (
                        <>

                          <StyledTableRow key={index2}>
                            <StyledTableCell component="th" scope="row" className={classes.textLeft}>
                              {r2.description}
                            </StyledTableCell>
                            <StyledTableCell style={{ textAlign: 'right' }}>
                              <div className={classes.warpButtonDetail}>
                                <FormControl variant="outlined" className={classes.formControl}>
                                  <TextField
                                    disabled={!r2.isApproved}
                                    type="number"
                                    variant="outlined"
                                    placeholder="วัน"
                                    className={classes.textField}
                                    name={`days_${index}_${index2}`}
                                    // name='days'
                                    value={r2.days}
                                    onChange={(event) => {
                                      const _configs = [...configs];
                                      let config = _configs[index].rows[index2];
                                      _configs[index].rows[index2] = {
                                        ...config,
                                        days: event.target.value,
                                      };
                                      console.log(config);
                                      setConfigs(_configs);
                                    }}
                                  />
                                </FormControl>

                              </div>
                            </StyledTableCell>
                            <StyledTableCell style={{ textAlign: 'right' }}>
                              <div className={classes.warpButtonDetail}>
                                <FormControl variant="outlined" className={classes.formControl}>

                                  <TextField
                                    disabled={!r2.isApproved}
                                    type="number"
                                    variant="outlined"
                                    placeholder="ชม."
                                    className={classes.textField}
                                    name={`hours_${index}_${index2}`}
                                    value={r2.hours}
                                    onChange={(event) => {
                                      const _configs = [...configs];
                                      let config = _configs[index].rows[index2];
                                      _configs[index].rows[index2] = {
                                        ...config,
                                        hours: event.target.value,
                                      };
                                      setConfigs(_configs);
                                    }}
                                  />
                                </FormControl>
                              </div>
                            </StyledTableCell>
                            <StyledTableCell style={{ textAlign: 'right' }}>
                              <div className={classes.warpButtonDetail}>
                                <FormControl variant="outlined" className={clsx(classes.formControl, classes.timeControl)}>

                                  <Select
                                    disabled={!r2.isApproved}
                                    value={r2.hourFactor || 8}
                                    onChange={(event) => {
                                      const _configs = [...configs];
                                      let config = _configs[index].rows[index2];
                                      _configs[index].rows[index2] = {
                                        ...config,
                                        hourFactor: +event.target.value,
                                      };
                                      setConfigs(_configs);
                                    }}
                                  >
                                    <MenuItem value={8}>เวลาราชการ</MenuItem>
                                    <MenuItem value={24}>เวลาปฎิทิน</MenuItem>
                                  </Select>
                                </FormControl>
                              </div>
                            </StyledTableCell>
                          </StyledTableRow>
                          {
                            !r2.isApproved &&
                            <StyledTableRow>
                              <StyledTableCell style={{ textAlign: 'right' }} colSpan={4}>
                                <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                                  <div style={{ display: 'inline-flex', alignItems: 'center', fontWeight: "500", color: "gray", paddingRight: 15 }}>
                                    รออนุมัติ {r2?.empRequestChange?.length} / 3
                                  </div>
                                  <Button variant="contained" size="medium" color="primary" onClick={() => handleApproveTime(r2)} className={classes.buttonDialogSave}
                                    style={{ width: '100px', backgroundColor: 'rgb(27, 167, 161)' }}
                                  // disabled={r2.empRequestChange?.map(x => x.empId).indexOf(profile.userID) > -1}
                                  >
                                    อนุมัติ
                                  </Button>
                                </div>


                              </StyledTableCell>
                            </StyledTableRow>
                          }

                        </>
                      ))
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            ))
          }
        </div>
      </div>

    </Paper >
  );
}

export default ConfigRequest;
